export const changeMembercode = code => {
	return { type: 'CHANGE_MEMBERCODE', payload: code };
};
export const changeLoginKey = code => {
	return { type: 'CHANGE_LOGINKEY', payload: code };
};
